/**
 * CanvasPresence — live/offline badge + overlapping avatars of everyone
 * currently in the board (mirrors the Newsletter CollabPresence chip).
 */
import React from 'react';
import { Wifi, WifiOff } from 'lucide-react';
import { T } from '../../../components/em/ui';

export default function CanvasPresence({ active, users = [] }) {
  const shown = users.slice(0, 4);
  const extra = users.length - shown.length;
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <span data-tip={active ? 'Live — changes sync in real time' : 'Offline'}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 5, font: `600 11px ${T.font}`, color: active ? '#059669' : T.fg7 }}>
        {active ? <Wifi size={13} /> : <WifiOff size={13} />} {active ? 'Live' : 'Offline'}
      </span>
      {shown.length > 0 && (
        <div style={{ display: 'inline-flex' }}>
          {shown.map((u, i) => (
            <span key={u.socketId} title={u.username}
              style={{ width: 26, height: 26, borderRadius: '50%', marginLeft: i ? -8 : 0,
                border: '2px solid var(--em-bg-card)', background: u.color || '#818cf8', color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center', font: `700 11px ${T.font}` }}>
              {(u.username || '?').slice(0, 1).toUpperCase()}
            </span>
          ))}
          {extra > 0 && (
            <span style={{ width: 26, height: 26, borderRadius: '50%', marginLeft: -8, border: '2px solid var(--em-bg-card)',
              background: T.bgMuted, color: T.fg4, display: 'flex', alignItems: 'center', justifyContent: 'center', font: `700 10px ${T.font}` }}>
              +{extra}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
